import { request, requestAPI } from '../../../../utils/request';
import {
  receiptsRequest,
  receiptsSuccess,
  receiptsFailure,
  setDisplayReceipts,
  receiptRequest,
  receiptSuccess,
  receiptFailure,
  setTotalReceipts,
} from './actions';
import message from '../../../../utils/message';
import { Dispatch, GetState } from '../../../../@types';
import { ReceiptsState } from './initialState';
import { APIFilterParams } from '../../ui/filters';

export const fetchReceipts =
  (
    offset: number,
    limit: number,
    successCallback?: Function,
    filterParams?: APIFilterParams
  ) =>
  (dispatch: Dispatch) => {
    dispatch(receiptsRequest());
    requestAPI('/fleets/receipts', {
      limit: limit.toString(),
      offset: offset.toString(),
      ...filterParams,
    })
      .then((data) => {
        dispatch(receiptsSuccess(data.receipts));
        dispatch(setDisplayReceipts(data.receipts));
        dispatch(setTotalReceipts(data.totalCount));
        if (successCallback && typeof successCallback === 'function') {
          successCallback();
        }
      })
      .catch((err) => {
        dispatch(receiptsFailure(err));
        message.error(err.message);
      });
  };

// Request deduplication is handled at the request level (request.ts)
export const fetchReceiptsIfNeeded = () => {
  return (dispatch: Dispatch) => {
    return dispatch(fetchReceipts(0, 1000));
  };
};

export const fetchReceiptById = (id: string) => (dispatch: Dispatch) => {
  dispatch(receiptRequest());

  requestAPI('/fleets/receipts/single', { receiptId: id })
    .then((res) => {
      if (res?.status !== 404) dispatch(receiptSuccess(res));
    })
    .catch((err) => {
      dispatch(receiptFailure(err));
      message.error(err.message);
    });
};
